module.exports = __webpack_public_path__ + "static/img/reddit.35952df.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/img/footer_icon/hover/reddit.png
// module id = hLU3
// module chunks = 0